import styles from '../InformationsForms/InformationFormsStyle.module.scss'
import { Col, Form, Input, Row } from "antd"

const NameField = ({ onChange, formValues, disabled ,errors}) => {
    return (
        <div className={styles.formContainer}>
            <Row gutter={16} className={styles.gridContainer}>
                <Col xs={24} md={12} lg={12}>
                    <Form.Item layout="vertical" label="First Name" required validateStatus={errors?.firstName ? 'error' : ''} help={errors?.firstName}>
                    <Input size="large" fullWidth placeholder="First Name" name="firstName" id="firstName" disabled={disabled} onChange={onChange} value={formValues?.firstName || ""} />
                    </Form.Item>
                </Col>
                <Col xs={24} md={12} lg={12}>
                    <Form.Item layout="vertical" label="Last Name" required validateStatus={errors?.lastName ? 'error' : ''} help={errors?.lastName}>
                    <Input size="large" fullWidth placeholder='Last Name' name="lastName" id="lastName" disabled={disabled} onChange={onChange} value={formValues?.lastName || ""} />
                    </Form.Item>
                </Col>
            </Row>
        </div>
    )
}
export default NameField
